// URL context never replaces an employee's assigned boutique. API permissions
// remain authoritative for every list, detail and action request.
export function schedulingEntryBoutique(user, requested) {
  return (
    user?.boutique_code ||
    (["PLT", "FLL", "WYN", "PNC"].includes(requested) ? requested : "PLT")
  );
}
